/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M13.5 16.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.25 5.25V9h2.25c1.6569 0 3 1.3431 3 3v9c0 1.6569-1.3431 3-3 3h-15c-1.6568 0-3-1.3431-3-3v-9c0-1.6569 1.3432-3 3-3h2.25V5.25C6.75 2.3505 9.1005 0 12 0c2.8028 0 5.0927 2.1964 5.2422 4.962l.0078.288Zm-2.6891-2.7394c-.628-.5872-1.4581-.9611-2.3744-1.006A3.8089 3.8089 0 0 0 12 1.5c-2.071 0-3.75 1.679-3.75 3.75V9h7.5V5.25c0-.0753-.0022-.15-.0066-.2242-.0584-.991-.5017-1.8785-1.1825-2.5152ZM15 16.5c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'LockFilled'
);
